/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Employees_ErrorInputs */

const es_tools_legajox_employees_error = /** @type {(inputs: Tools_Legajox_Employees_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al consultar empleados de Legajox`)
};

const en_tools_legajox_employees_error = /** @type {(inputs: Tools_Legajox_Employees_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error querying Legajox employees`)
};

/**
* | output |
* | --- |
* | "Error querying Legajox employees" |
*
* @param {Tools_Legajox_Employees_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_employees_error = /** @type {((inputs?: Tools_Legajox_Employees_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Employees_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_employees_error(inputs)
	return en_tools_legajox_employees_error(inputs)
});
export { tools_legajox_employees_error as "tools.legajox.employees_error" }